/**
 * Convert the input string to title case.
 *
 * @param {string} s - the input string
 * @return {string} the string converted to title case
 */
export const titleCase = (s: string): string =>
  s.replace(/^_*(.)|_+(.)/g, (match, firstChar, subsequentChar) =>
    firstChar ? firstChar.toUpperCase() : ' ' + subsequentChar.toUpperCase()
  );

/**
 * Verify if the string is a UUIDv4.
 *
 * @param {string} str - the input string
 * @return {boolean} boolean value indicating the result of the test.
 */
export const stringIsUuidv4 = (str: string): boolean =>
  new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$').test(str);
